export const IdleTimerConstants = {
    lockUser : 'lockUser',
    terminateUser : 'terminateUser',
}